import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../common/Translate';

const MeetingTag = ({ code }) => {
  let color;
  let label;

  switch (code) {
    case 0:
      color = 'white';
      label = 'record_creation';
      break;
    case 1:
      color = 'white';
      label = 'expertise_restarted';
      break;
    case 2:
      color = 'white';
      label = 'expertise_started';
      break;
    case 3:
      color = 'orange';
      label = 'expertise_finished';
      break;
    case 4:
      color = 'green';
      label = 'supervisor_authorized';
      break;
    case 5:
      color = 'green';
      label = 'auto_accept';
      break;
    case 6:
      color = 'red';
      label = 'supervisor_refused';
      break;
    case 7:
      color = 'red';
      label = 'refused';
      break;
    case 8:
      color = 'white';
      label = 'report';
      break;
    case 9:
      color = 'white';
      label = 'transaction';
      break;
    case 10:
      color = 'white';
      label = 'finish';
      break;
    case 11:
      color = 'white';
      label = 'closed';
      break;
    case 12:
      color = 'red';
      label = 'expertise_interrupted';
      break;
    case 13:
      color = 'white';
      label = 'justified';
      break;
    case 14:
      color = 'white';
      label = 'reported_ongoing';
      break;
    case 15:
      color = 'white';
      label = 'old_flow';
      break;
    case 16:
      color = 'white';
      label = 'repurchase';
      break;
    case 17:
      color = 'white';
      label = 'outdated';
      break;
    case 18:
      color = 'white';
      label = 'appointement';
      break;
    case 19:
      color = 'white';
      label = 'appointement_canceled';
      break;
    case 20:
      color = 'white';
      label = 'not_show';
      break;
    case 21:
      color = 'white';
      label = 'come_left';
      break;
    case 30:
      color = 'brink-pink';
      label = 'waitingForCounterAppraisal';
      break;
    case 35:
      color = 'brink-pink';
      label = 'counterAppraisalOngoing';
      break;
    case 40:
      color = 'orange';
      label = 'counterAppraisalVerification';
      break;
    default:
      color = 'white';
      label = (code && code) || null;
      break;
  }

  if (!code) return <span className="badge calendar-badge meeting-tag">null</span>;
  return <span className={`badge calendar-badge calendar-badge-${color} meeting-tag`}>{label && t(label)}</span>;
};

export default MeetingTag;

MeetingTag.propTypes = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
